import React, { useState, useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { find, first } from 'lodash';

import { getAbbreviation } from '../../app/utils/strings';

function ProfilesCollapseCardContainer({
  intl,
  teacher,
  color,
  messages,
  getTeachers,
  removeTeacher,
  changeTeacherEdit,
  selectTeacherToRemove,
}) {
  const [isOpen, setOpen] = useState(false);
  const [edit, setEdit] = useState({});
  const [dataLoaded, setDataStatus] = useState(false);

  const name = teacher.name || '';
  const initials = getAbbreviation(name);

  const profiles = teacher.profiles
    ? teacher.profiles.map((p) => ({
        ...p,
        dataCSchool: p.dataCSchool
          ? p.dataCSchool.map((d) => ({ ...d, idESUser: p.idESUser }))
          : [],
      }))
    : [];

  return (
    <div className="card mb-3">
      <div className="collapsible card-body">
        <div className="row align-items-center" onClick={() => setOpen(!isOpen)}>
          <div className="col-auto">
            <div
              className="class-prefix class-prefix-variation m-0"
              style={{ color: '#FFFFFF', backgroundColor: color }}
            >
              {initials}
            </div>
          </div>
          <div className="col-7">
            <h2>{name}</h2>
          </div>
          <div className="col-auto ml-auto" onClick={() => setOpen(!isOpen)}>
            <i className={`fa fa-chevron-${isOpen ? 'up' : 'down'}`} />
          </div>
        </div>
        {profiles.map((profile) => {
          const isCondinator = profile.permission === '1';
          const role = isCondinator ? 'coordinator' : 'teacher';
          const schools = profile.dataCSchool.map((p) => ({ ...p, idESUser: profile.idESUser }));

          return (
            <div id="collapseOne" className={`collapse ${isOpen ? 'show' : ''}`}>
              <div className="row mt-4">
                {schools.map((school, index) => {
                  const evaluations = school.evaluations
                    ? school.evaluations.map((e) => ({
                        ...e,
                        idESUser: school.idESUser,
                      }))
                    : [];

                  return (
                    <Fragment key={school.idCSchool}>
                      <div
                        className="m-0 p-0"
                        style={{ display: 'flex', width: '100%', alignItems: 'center' }}
                      >
                        <div className="col-11">
                          <h4 className="card-title" style={{ color: '#FF836A' }}>
                            {intl.formatMessage(messages.schools)} {school.name}
                          </h4>
                          <h5 className="card-title">{intl.formatMessage(messages[role])}</h5>
                        </div>
                        {isCondinator && (
                          <div className="col-1">
                            <button
                              className="edit-card edit-card-variation edit-card-variation-profile"
                              onClick={() => removeTeacher(profile.idESUser)}
                              style={{ width: '35px', fontSize: '0.7rem' }}
                            >
                              <i className="pe-7s-close-circle" />
                              {intl.formatMessage(messages.remove)}
                            </button>
                          </div>
                        )}
                      </div>
                      <hr className="mt-2" />
                      {evaluations.map((ev) => {
                        const names = ev.catalogings.map((c) => c.name);
                        let classes = ev.catalogings.map((c) => c.catalogingLevel);
                        classes = classes.filter((v, i, a) => a.indexOf(v) === i);
                        let title = '';
                        names.map((c, i) => {
                          if (i === 0) {
                            title = c;
                          } else if (i + 1 === names.length) {
                            title = title.concat(` e ${c}`);
                          } else {
                            title = title.concat(`, ${c}`);
                          }
                        });

                        return (
                          <div className="row" style={{ margin: '0', width: '100%' }}>
                            <div className="col-12">
                              <hr className="mt-2" />
                            </div>
                            <div className="col-10">
                              <p className="card-title">
                                {classes.length > 1 ? classes[0] : classes}
                              </p>
                              <h4 className="card-title">{title}</h4>
                              <p className="card-title">{ev.identification}</p>
                              <p className="card-title" style={{ color: '#B5B5B5' }}>
                                ID: {ev.id}
                              </p>
                            </div>
                            <div
                              className="col-2"
                              style={{ display: 'flex', justifyContent: 'flex-end' }}
                            >
                              <button
                                className="edit-card edit-card-variation edit-card-variation-profile"
                                onClick={() =>
                                  selectTeacherToRemove({
                                    idESUser: profile.idESUser,
                                    idCSchool: profile.idCSchool,
                                    idEvaluation: ev.id,
                                  })
                                }
                              >
                                <i className="pe-7s-close-circle" />
                                {intl.formatMessage(messages.remove)}
                              </button>
                            </div>
                            {/* <div className="col-12 mt-5 mb-5">
                              <ul
                                style={{
                                  listStyle: 'none',
                                  marginBottom: '0',
                                  height: '100%',
                                  padding: '0',
                                }}
                              >
                                <li
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <label htmlFor={`switch${ev.idESUser}-${ev.id}`}>
                                    {intl.formatMessage(messages.edition)}
                                  </label>
                                  <span className="switch mr-0 float-right">
                                    <input
                                      id={`switch${ev.idESUser}-${ev.id}`}
                                      type="checkbox"
                                      checked={ev.edit === '1'}
                                      onChange={() => {
                                        setEdit({ ...edit, [ev.id]: !edit[ev.id] });
                                        changeTeacherEdit({
                                          idESUser: ev.idESUser,
                                          idEvaluation: ev.id,
                                          edit: ev.edit === '1' ? '0' : '1',
                                          viewEvaluation: ev.viewEvaluation,
                                          validateQuestions: ev.validateQuestions,
                                        });
                                        setTimeout(() => getTeachers(), 1000);
                                      }}
                                    />
                                    <label htmlFor={`switch${ev.idESUser}-${ev.id}`} />
                                  </span>
                                </li>
                                <li
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <label htmlFor={`switch${ev.idESUser}-access-${ev.id}`}>
                                    {intl.formatMessage(messages.accessAssessment)}
                                  </label>
                                  <span className="switch mr-0 float-right">
                                    <input
                                      id={`switch${ev.idESUser}-access-${ev.id}`}
                                      type="checkbox"
                                      checked={ev.viewEvaluation === '1'}
                                      onChange={() => {
                                        // setEdit({ ...edit, [ev.id]: !edit[ev.id] });
                                        changeTeacherEdit({
                                          idESUser: ev.idESUser,
                                          idEvaluation: ev.id,
                                          edit: ev.edit,
                                          viewEvaluation: ev.viewEvaluation === '1' ? '0' : '1',
                                          validateQuestions: ev.validateQuestions,
                                        });
                                        setTimeout(() => getTeachers(), 1000);
                                      }}
                                    />
                                    <label htmlFor={`switch${ev.idESUser}-access-${ev.id}`} />
                                  </span>
                                </li>
                                <li
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <label htmlFor={`switch${ev.idESUser}-validate-${ev.id}`}>
                                    {intl.formatMessage(messages.validateQuestions)}
                                  </label>
                                  <span className="switch mr-0 float-right">
                                    <input
                                      id={`switch${ev.idESUser}-validate-${ev.id}`}
                                      type="checkbox"
                                      checked={ev.validateQuestions === '1'}
                                      onChange={() => {
                                        // setEdit({ ...edit, [ev.id]: !edit[ev.id] });
                                        changeTeacherEdit({
                                          idESUser: ev.idESUser,
                                          idEvaluation: ev.id,
                                          edit: ev.edit,
                                          viewEvaluation: ev.viewEvaluation,
                                          validateQuestions:
                                            ev.validateQuestions === '1' ? '0' : '1',
                                        });
                                        setTimeout(() => getTeachers(), 1000);
                                      }}
                                    />
                                    <label htmlFor={`switch${ev.idESUser}-validate-${ev.id}`} />
                                  </span>
                                </li>
                              </ul>
                            </div> */}
                          </div>
                        );
                      })}
                    </Fragment>
                  );
                })}
              </div>

              {!isCondinator && (
                <div>
                  <hr style={{ margin: '10px -20px' }} />

                  <Link
                    to={`/profiles/add?idESUser=${profile.idESUser}&idCSchool=${profile.idCSchool}`}
                    className="card add-new card-list add-new-profile mb-0"
                    style={{ marginLeft: '-20px', marginRight: '-20px' }}
                  >
                    <span>
                      <div className="container">
                        <div className="row align-items-center">
                          <div className="col-auto ml-auto">
                            <div className="add-icon my-0">
                              <i className="ti-plus" />
                            </div>
                          </div>
                          <div className="col-auto mr-auto">
                            {intl.formatMessage(messages.addEvaluation)}
                          </div>
                        </div>
                      </div>
                    </span>
                  </Link>
                </div>
              )}

              <hr style={{ margin: '10px -20px' }} />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default injectIntl(ProfilesCollapseCardContainer);
